import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, getJwtFromCookies } from "../module_auth/AuthService"
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";
import { getTextWorkCity, getTextWorkTime, getTextVisaStat, formatDate, sendGoogleAnalytics } from "../component/common/BaseUtil"
import '../App.css';
import { useLocation } from "react-router-dom";

export function Person() {
    const location = useLocation();

    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    //구직상세
    const [objTitle, setObjTitle] = useState("");
    const [fullname, setFullname] = useState("");
    const [telno, setTelno] = useState("");
    const [email, setEmail] = useState("");
    const [workCity, setWorkCity] = useState("0");
    const [workTime, setWorkTime] = useState("0");
    const [visaStat, setVisaStat] = useState("");
    const [eduHist, setEduHist] = useState('');
    const [resumeHist, setResumeHist] = useState('');
    const [pvIntro, setPvIntro] = useState('');
    const [redirect, setRedirect] = useState(false);
    const [updateAt, setUpdateAt] = useState("");
    const [nickname, setNickname] = useState("");
    const [hits, setHits] = useState("");
    //End 구직상세

    const [cityList, setCityList] = useState([]);

    const [token, setToken] = useState("");

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        setToken(getJwtFromCookies())
        let url = basePort + '/get/person/' + id
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                console.log(response)
                setObjTitle(response.objTitle)
                setFullname(response.fullname)
                setTelno(response.telno)
                setEmail(response.email)
                setWorkCity(response.workCity)
                setWorkTime(response.workTime)
                setVisaStat(response.visaStat)
                setEduHist(response.eduHist)
                setResumeHist(response.resumeHist)
                setPvIntro(response.pvIntro)
                setUpdateAt(response.updateAt)
                setNickname(response.nickname)
                console.log("response.nickname: " + response.nickname)
                setHits(response.hits)
                getCityList()
          }).catch(error => console.log(error))
    }, []);

    let navigate = useNavigate();    
    function backToList() {
        let returnTo = queryParameters.get("returnTo");
        let returnPage = localStorage.getItem("page")
        let pageList = returnPage == null ? 1 : returnPage
        let url
        if(returnTo === "/person_list"){
            url = returnTo + "?page=" + pageList;
        } else {
            // home, mypage
            url = returnTo;
        }
        //let url = "/person_list?page=" + pageList;
        navigate(url);
    }

    function getCityList(){
        let url = basePort + '/get/config'
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
               console.log(response.cityEntityList)
               setCityList(response.cityEntityList)
          }).catch(error => console.log(error))
    }

    function backToLogin() {
        let returnTo = queryParameters.get("returnTo");
        let returnPage = localStorage.getItem("page")
        let pageList = returnPage == null ? 1 : returnPage
        let url
        if(returnTo === "/person_list"){
            url = returnTo + "?page=" + pageList;
        } else {
            // home, mypage
            url = returnTo;
        }
        navigate(url);
    }

    function telNoEmailComponent(token) {
        if (token == undefined) {
          return <li class="list-group-item"><button class="btn btn-dark btn-sm text-end" type="button" style={{borderRadius: '5px'}} onClick={backToLogin}>연락처, 이메일 보기</button></li>;
        }
        return <><li class="list-group-item"><span>이메일: {email}</span></li><li class="list-group-item"><span>연락처: {telno}</span></li></>;
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container responsive-container-width" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>인재정보</span></li>
                            <li class="breadcrumb-item"><span>인재상세</span></li>
                        </ol>

                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title"
                                    style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>{objTitle}</h4>
                            </div>
                        </div>
                        <div class="row" style={{marginBottom:'50px'}}>
                            <label class="form-label">
                                <span style={{fontSize:'14px', marginLeft:"10px"}}>닉네임: {nickname} 작성일: {formatDate(updateAt)} 조회: {hits}</span>
                            </label>
                        </div>
                        <h4 style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>인재정보</h4>
                        <div className="card" style={{marginBottom: '50px'}}>
                            <div className="card-body">
                                <div class="container text-left">
                                    <div class="row g-2">
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">이름: {fullname}</div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">연락처: {telno}</div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">근무도시: {getTextWorkCity(cityList, workCity)}</div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">근무형태: {getTextWorkTime(workTime)}</div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">비자상태: {getTextVisaStat(visaStat)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h4 style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>학력사항</h4>
                        <div className="card" style={{marginBottom: '50px'}}> 
                            <div className="card-body">
                                <div class="container text-left">
                                    <div class="row g-2" >
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">{eduHist === null ? "" : parse(eduHist)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h4 style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>경력사항</h4>
                        <div className="card" style={{marginBottom: '50px'}}> 
                            <div className="card-body">
                                <div class="container text-left">
                                    <div class="row g-2" >
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">{resumeHist === null ? "" : parse(resumeHist)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h4 style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>자기소개</h4>
                        <div className="card" style={{marginBottom: '50px'}}> 
                            <div className="card-body">
                                <div class="container text-left">
                                    <div class="row g-2" >
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="p-3">{pvIntro === null ? "" : parse(pvIntro)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{margintop: '10px'}}>
                        <ul class="pagination">
                            <li class="page-item"><a class="page-link" onClick={backToList}>목록</a></li>
                        </ul>
                    </nav>
                </section>
            </main>
        </div>
    );
}